// extracted by mini-css-extract-plugin
export default {"FCoverFooterButtons":"FCoverFooterButtons___mjqv9","disabled":"disabled___IQiR2"};